export const SET_MAIL_ACTIVITY_FILTER = 'SET_MAIL_ACTIVITY_FILTER';